<template>
  <div>
    <h4 class="headerTitle mt-2">
      Nascido
    </h4>
    <form autocomplete="off"
          class="px-2 mt-2 pt-2">
      <div class="row">
        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label for="cpf"
                   class="label">CPF</label>
            <div class="input-group">
              <input id="cpf"
                     v-model="pessoa.cpf"
                     v-mask="'999.999.999-99'"
                     type="text"
                     class="form-control form-control-sm"
                     name="cpf"
                     placeholder="000.000.000-00"
                     @change="searchCPF">
              <div class="input-group-append" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-9">
          <div class="form-group">
            <label class="label"
                   for="nome">Nome </label>
            <input id="nome"
                   ref="nascido_nome"
                   v-model="pessoa.nome"
                   v-validate="'required'"
                   :class="{ 'is-invalid': errors.has('nome') }"
                   class="form-control form-control-sm text-uppercase"
                   name="nome"
                   placeholder="Enzo Silva"
                   required
                   type="text"
                   @change="changeData(), upperName()">
            <small v-if="errors.has('nome')"
                   class="invalid-feedback">{{ errors.first('nome') }}</small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="dataNascimento">Data Nascimento</label>
            <input id="dataNascimento"
                   v-model="pessoa.data_nascimento"
                   v-mask="'##/##/####'"
                   v-validate="`required|date_format:dd/MM/yyyy|date_between:01/01/1500,${limitDate}|max_date:${new Date()}`"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('dataNascimento') }"
                   maxlength="10"
                   name="dataNascimento"
                   placeholder="00/00/0000"
                   required
                   type="text"
                   @blur="changeData()">
            <small v-if="errors.has('dataNascimento')"
                   class="invalid-feedback">{{ errors.first('dataNascimento') }}</small>
          </div>
        </div>

        <div class="col-12 col-lg-2 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="horaNascimento">Hora Nascimento</label>
            <input id="horaNascimento"
                   ref="horaNascimento"
                   v-model="pessoa.hora_ocorrido"
                   v-mask="'99:99'"
                   v-validate="'validateHour'"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.first('horaNascimento') }"
                   maxlength="5"
                   name="horaNascimento"
                   placeholder="00:00"
                   type="text"
                   @change="changeData()">
            <small v-if="errors.has('horaNascimento')"
                   class="invalid-feedback">{{ errors.first('horaNascimento') }}</small>
          </div>
        </div>

        <div class="col-12 col-lg-2 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="sexoNascido">Sexo</label>
            <select id="sexoNascido"
                    v-model="pessoa.sexo"
                    class="custom-select custom-select-sm"
                    name="sexoNascido"
                    @change="changeData()">
              <option selected
                      value="">
                Selecione
              </option>
              <option v-for="sexo in SEXOS"
                      :key="sexo.value"
                      :value="sexo.value">
                {{ sexo.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12 col-lg-3 col-sm-3">
          <div class="form-group"
               style="white-space: nowrap;">
            <label class="label"
                   for="decNascidoVivo">Nº Declaração Nascido Vivo</label>
            <input id="decNascidoVivo"
                   v-model="pessoa.numero_declaracao_nascido_vivo"
                   data-vv-validate-on="custom|blur"
                   :class="{ 'is-invalid': errors.has('decNascidoVivo') }"
                   class="form-control form-control-sm"
                   maxlength="11"
                   name="decNascidoVivo"
                   type="text">
            <small v-if="errors.has('decNascidoVivo')"
                   class="invalid-feedback">{{ errors.first('decNascidoVivo') }}</small>
          </div>
        </div>
      </div>
    </form>

    <Genitores :genitores="genitores"
               :endereco-registrado="enderecoRegistrado"
               :campo-declarante="true"
               :prop-cartorio="propCartorio"
               :prop-validate="true"
               :prop-nascimento="true"
               prop-tipo-registro="N"
               :prop-data="{ registro: { pessoa: { data_nascimento: pessoa.data_nascimento } } }"
               @genitorAdded="getGenitores"
               @genitorRemoved="removeGenitor"
               @genitorUpdated="updateGenitor" />

    <!--  LOCAL OCORRêNCIA  -->
    <LocalOcorrencia :num-dnv="registro.numero_declaracao_nascido_vivo"
                     :local="local"
                     :prop-legado="true"
                     :prop-cartorio="propCartorio"
                     :prop-rascunho="true"
                     @clearEditOcorrencia="clearEditOcorrencia"
                     @receiveOcorrencia="receiveOcorrencia"
                     @removeOcorrencia="removeOcorrencia" />

    <!-- Naturalidade -->
    <div>
      <div class="headerTitle mt-4 mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="headerTitleB2_title">
            Naturalidade
          </h4>
        </div>
      </div>
      <form autocomplete="off">
        <div class="col-12 p-0">
          <div class="col pb-2">
            <b-form-radio v-model="naturalidade_origem"
                          name="some-radios"
                          value="endereco_ocorrencia"
                          @change="changeTipoNaturalidade">
              A mesma do local da ocorrência
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_ocorrencia"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
          <div class="col pb-2">
            <b-form-radio v-model="naturalidade_origem"
                          name="some-radios"
                          value="endereco_mae"
                          @change="changeTipoNaturalidade">
              A mesma da residência cadastrada da mãe biológica
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_mae"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
          <div v-if="nome_pai"
               class="col pb-2">
            <b-form-radio v-model="naturalidade_origem"
                          name="some-radios"
                          value="endereco_pai"
                          @change="changeTipoNaturalidade">
              A mesma de <span class="text-capitalize">{{ nome_pai | firstCapitalize }}</span>
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_pai"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
        </div>
      </form>
    </div>

    <!--  GÊMEOS  -->
    <BoxFormGemeos :lista="gemeos"
                   :prop-ordem-nascimento="ordem_nascimento"
                   @addGemeo="addGemeo"
                   @removeGemeo="removeGemeo"
                   @cleanGemeos="cleanGemeos"
                   @updateGemeo="updateGemeo"
                   @changeOrdemNascimento="changeOrdemNascimento" />

    <b-modal v-if="rascunhoFound"
             id="modalRascunho"
             ref="modalRascunho"
             no-close-on-backdrop
             no-close-on-esc
             :visible="true"
             centered
             size="xl">
      <div slot="modal-header"
           class="modalGenitor_title w-100">
        Rascunho encontrado
      </div>
      <SearchRascunho :prop-rascunho="rascunhoFound"
                      :prop-segunda-via="true" />
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <button class="btn btn-sm btn-primary"
                @click="() => { cancel(); setDataNascido(); }">
          Continuar com o Cadastro
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>

/* constants */
  import objSwal from '@/constants/swalValues'
  import SEXOS from "@/constants/sexos"
  import Cidades from "@/constants/repositorio/cidades"

  /* components */
  import Genitores from '../../Obito/Passos/Sessoes/Genitores.vue'
  import BoxFormGemeos from '../BoxFormGemeos.vue'
  import LocalOcorrencia from '@/components/SofiaRei/Nascimento/LocalOcorrencia'
  import SearchRascunho from "@/components/SofiaRei/Busca/SearchRascunho.vue"

  /* services */
  import EnderecosService from "@/services/Enderecos"
  import NascimentoService from "@/services/Registros/Nascimento"
  import PessoasService from "@/services/Pessoas"
  import BuscaService from "@/services/BuscaService"
  import ValidateDeclarationService from "@/services/Registros/ValidateDeclarationService"

  /* utils */
  import { validateHour } from '@/utils/validation'
  import { document } from '@/utils/nascObject'

  /* others */
  import Swal from 'sweetalert2'
  import moment from "moment"
  import { mapGetters } from 'vuex'
  import {filterDate, filterMaskedNumber} from "@/filters/filters"


  export default {
    name: 'NascidoLegado',
    inject: ['$validator'],
    components: {
      SearchRascunho,
      Genitores,
      BoxFormGemeos,
      LocalOcorrencia,
    // AverbacaoSV
    },
    props: {
      dados: { type: Object, default: () => ({}) },
      propCartorio: { type: Object, default: () => { return {} }},
      propRegistro: { type: Object, default: () => { return {} }},
      propUpdated: { type: Boolean, default: false},
    },
    data () {
      return {
        showModal: false,
        document,
        idNasc: null,
        id: null,
        enderecoRegistrado: {},
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
        pessoa: {
          nome: '',
          data_nascimento: '',
          cpf_origem: null
        },
        registro: {
          pessoa: {
            sexo: '',
            genitores: []
          },
          cartorio_id: this.$store.state.auth.cartorio_id,
          tipo_registro: 'N',
          partes: []
        },
        local: {},
        toEditLocalOcorrencia: {},
        nascimento: {},
        gemeos: [],
        genitores: [],
        avos: [],
        idade_mae: null,

        // FUTURAS ALTERAÇÕES
        localData: {
          nacionalidade: {
            nacionalidade_codigo: 76,
            nome: 'Brasil',
            nome_masculino: 'brasileiro',
            nome_feminino: 'brasileira'
          }
        },
        naturalidade: '',
        naturalidade_origem: 'endereco_ocorrencia',
        naturalidadeControl: {
          alerts: {
            endereco_ocorrencia: false,
            endereco_mae: false,
            endereco_pai: false,
            mensagem: null
          }
        },
        selectsOptions: {
          states: [],
          cities: [],
        },
        SEXOS,
        nome_pai: null,
        ordem_nascimento: null,
        showModalRascunho: false,
        rascunhoFound: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
      // FUTURAS ATUALIZAÇÕES
      citiesFiltered () {
        if (this.localData.uf) {
          const stateSelected = this.selectsOptions.states.find(state => state.uf == this.localData.uf)
          return this.selectsOptions.cities.filter(city => city.nome === 'Outro' || city.state_id == stateSelected.id)
        }
        return this.selectsOptions.cities
      },
    },
    watch: {
      propUpdated () {
        this.changeData()
      }
    },
    created () {
      this.selectsOptions.states = EnderecosService.getStates()
      this.selectsOptions.cities = Cidades

      this.$validator.extend('validateHour', validateHour)
    },
    mounted () {
      let { idNasc } = this.$route.params

      this.id = this._uid

      if ((idNasc !== 'novo')) {
        this.idNasc = idNasc
        this.checkData()
      }
    },
    methods: {
      changeCpf () {
        if (this.idNasc) {
          this.changeData()
        }
      },
      async searchCPF () {
        try {
          let cpf = filterMaskedNumber(this.pessoa.cpf)
          if (cpf && cpf.length > 10) {
            const dados = await PessoasService.getPessoaByCPF(cpf)
            if (dados.isEmpty) return

            const { nome, datanascimento, sexo } = dados
            const sexos = {
              1: 'M',
              2: 'F'
            }

            let dataNascimento = filterDate(datanascimento)
            this.pessoa.nome = nome
            const data = dataNascimento.split('/').reverse().join('-')
            this.pessoa.data_nascimento = moment(data).format('DD/MM/YYYY')

            if ((sexos[sexo] === 'F' || sexos[sexo] === 'M')) {
              this.pessoa.sexo = sexos[sexo]
            } else {
              this.pessoa.sexo = 'I'
            }

            this.pessoa.cpf = this.pessoa.cpf || null

            if (this.pessoa.nome && this.pessoa.data_nascimento) {
              this.changeData()
            }
          }
        } catch (e) {
          this.changeCpf()
        }
      },
      changeData () {
        let { idNasc } = this.$route.params

        const {nome, data_nascimento } = this.pessoa

        if (nome && data_nascimento) {
          return (idNasc !== 'novo') ? this.updateDataNascido() : this.searchRascunho()
        }
      },
      sendDataToContainer () {
        loader({ text: '', active: false })
        return this.$emit('receiveNascido', this.mountObj())
      },
      // async checkDnv () {
      //   //Pega o ano do nascimento para validar o DNV
      //   const birthYear = moment(this.pessoa.data_nascimento).format("YYYY")
      //   let DNV = this.pessoa.numero_declaracao_nascido_vivo ? this.pessoa.numero_declaracao_nascido_vivo.replace(/[-_]/ig, '') : ''


      //   if (DNV.length == 0) return

      //   //43700000 é a numeração maxima da promeira versão do DNV
      //   if (DNV.length === 8 && DNV > 43700000) return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida, numeração superior ao limite da versão`)

      //   // caso o ano seja 2006 deve aceitar ambas as versões de DNV
      //   if (DNV.length === 8 && birthYear >= 2007) { // Não aceita DNV com 8 digitos depois de 2007
      //     DNV = ''
      //     this.dnv = ''
      //     return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida para o ano informado`)
      //   }
      //   if (DNV.length === 11 && birthYear <= 2005) { // Não aceita DNV com 11 digitos antes de 2005
      //     DNV = ''
      //     this.dnv = ''
      //     return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida para o ano informado`)
      //   }

      //   try {
      //     loader({ text: 'Validando DNV', active: true })
      //     const valid = await ValidateDeclarationService.validateDnv(DNV,null, birthYear)

      //     if (valid) {
      //       this.pessoa.numero_declaracao_nascido_vivo = DNV
      //       await this.changeData()
      //     }
      //   } catch (e) {
      //     objSwal.error.title = ''
      //     objSwal.error.text = e.response.data && e.response.data.message ? e.response.data.message : `D.N.V Número ${DNV} não é válida`
      //     objSwal.error.html = ''

      //     this.pessoa.numero_declaracao_nascido_vivo = null

      //     await Swal.fire(objSwal.error)
      //   } finally {
      //     loader({ text: '', active: false })
      //   }
      // },
      mountObjRetorno (val) {
        this.document = val.document
        this.gemeos = val.document.gemeos
        this.registro = val.document.registro
        this.genitores = val.document.registro.pessoa.genitores
        this.avos = val.document.avos
        this.local = val.document.local || {}
        this.naturalidade = this.document.registro.pessoa.naturalidade
        this.naturalidade_origem = this.document.registro.pessoa.naturalidade_origem
        this.pessoa = {
          ...val.document.registro.pessoa,
          data_nascimento: moment(val.document.registro.pessoa.data_nascimento).format('DD/MM/YYYY') || '',
          nacionalidade_codigo: 76
        },
        this.idade_mae = this.document.nascimento_informacao.idade_mae
        this.ordem_nascimento = this.document.ordem_nascimento
      },
      mountObj () {
        return {
          gemeos: this.gemeos,
          avos: this.avos,
          local: this.local || this.document.local,
          // Partes cadastradas nos próximos passos
          registro: {
            rascunho_id: this.nascimento.rascunho_id,
            ...this.document.registro,
            ...this.registro,
            ...this.propRegistro.registro,
            hora_ocorrido: this.pessoa.hora_ocorrido,
            numero_declaracao_nascido_vivo: this.pessoa.numero_declaracao_nascido_vivo,
            pessoa: {
              ...this.pessoa,
              data_nascimento: moment(this.pessoa.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              nacionalidade_codigo: 76,
              genitores: this.genitores
            },
            data_ocorrido: moment(this.pessoa.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
          },
          recem_nascido: this.document.recem_nascido,
          nascimento_informacao: {
            ...this.document.nascimento_informacao,
            idade_mae: this.idade_mae
          },
          cpf: this.pessoa.cpf,
          nome_registrado: this.pessoa.nome,
          ordem_nascimento: this.ordem_nascimento
        }
      },
      async updateDataNascido () {
        let { idNasc } = this.$route.params

        try {
          await NascimentoService.updateNascimentoRasc(idNasc, { document: this.mountObj() }).then( () => {
            loader({ text: '', active: false })
            return this.sendDataToContainer()
          })
        } catch (e) {
          return this.getAnError(e.message)
        }
      },
      async searchRascunho () {
        this.rascunhoFound = await BuscaService.searchRascunhoBeforeSave(this.registro, this.pessoa)
        if (this.rascunhoFound) {
          this.showModalRascunho = true
        } else {
          await this.setDataNascido()
        }
      },
      async setDataNascido () {
        loader({ text: 'Gravando dados...', active: true })

        try {
          await NascimentoService.storeNascimentoRasc({ document: this.mountObj() }).then(val => {
            this.nascimento = val
            this.sendDataToContainer(val)

            this.$toast.success('Rascunho salvo com sucesso!', {
              position: 'top-right',
              duration: 5000
            })
            this.$refs.horaNascimento.focus()
            this.$emit('rascunhoId', this.nascimento.rascunho_id)
            this.$router.push({ name: 'cadastro_nascimento_legado', params: { idNasc: val.rascunho_id } })
          })
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        }
      },
      async checkData () {
        let { idNasc } = this.$route.params

        if (idNasc === 'novo') return
        loader({ text: 'Buscando dados...', active: true })

        try {
          await NascimentoService.getNascimentoRascById(idNasc).then(val => {
            this.mountObjRetorno(val)
            this.getNomePai()
            return this.sendDataToContainer()
          })
        } catch (e) {
          console.error(e)
          this.$router.push('/pagina-nao-encontrada')
          loader({ text: '', active: false })
        }
      },
      getAnError (text) {
        loader({ text: '', active: false })

        objSwal.error.title = 'Erro ao cadastrar'
        objSwal.error.text = text || 'Houve algum erro ao cadastrar um novo registro de nascimento, favor contactar o suporte'
        return Swal.fire(objSwal.error)
      },
      changeOrdemNascimento (ordemNascimento) {
        this.ordem_nascimento = ordemNascimento

        this.changeData()
      },
      cpfDuplicate (genitor) {
        let duplicated = false
        let genitorDuplicado = null

        objSwal.success.title = 'Genitor atualizado com sucesso!'
        objSwal.success.text = ''
        objSwal.success.html = ''

        Swal.fire(objSwal.success)

        this.genitores.forEach((gen, index) => {
          if (index != genitor.localId) {
            if (gen.pessoa.cpf && gen.pessoa.cpf === genitor.pessoa.cpf) {
              duplicated = true
              genitorDuplicado = gen
            }
          }
        })

        if (genitorDuplicado) {
          objSwal.error.title = `CPF já cadastrado para o genitor ${genitorDuplicado.pessoa.nome}`
          objSwal.error.text = ''
          objSwal.error.html = ''
          Swal.fire(objSwal.error)
        }

        return duplicated
      },

      getGenitores (val) {
        if (!this.cpfDuplicate(val)) {
          this.genitores.push({ ...val, declarante: val.declarante })

          objSwal.success.title = "Adicionado com Sucesso"
          objSwal.success.text = ''
          Swal.fire(objSwal.success).then(() => {
            setTimeout(() => {
              const btnAdd = window.document.querySelector('.btn-add-genitor')

              if (btnAdd) btnAdd.focus()
            }, 200)
          })

          setTimeout(() => {
            const btnConfirm = window.document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)

          this.changeData()
          this.changeTipoNaturalidade()
          this.getIdadeMae()
          this.getNomePai()
        }
      },
      updateGenitor (val, ind) {
        if (!this.cpfDuplicate(val, ind)) {
          this.genitores[ind] = val
          this.changeTipoNaturalidade()
          this.changeData()
          this.getNomePai()

          objSwal.success.title = ''
          objSwal.success.text = 'Genitor atualizado com sucesso!'
          objSwal.success.html = ''

          Swal.fire(objSwal.success)

          setTimeout(() => {
            const btnConfirm = window.document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)
        }

        this.getIdadeMae()
      },
      removeGenitor (val) {
        this.genitores.splice(val, 1)
        this.changeData()
        this.changeTipoNaturalidade()
        this.getIdadeMae()
        this.getNomePai()
      },
      addGemeo (val) {
        this.gemeos.push(val)
        this.changeData()
      },
      removeGemeo (id) {
        this.gemeos.splice(id, 1)

        objSwal.success.title = 'Gêmeo removido com sucesso'
        objSwal.success.text = ''
        return Swal.fire(objSwal.success).then( () => this.changeData())
      },
      cleanGemeos () {
        this.gemeos = []
        this.changeData()
      },
      updateGemeo (gemeo) {
        this.gemeos[gemeo.index] = gemeo

        objSwal.success.title = 'Gêmeo atualizado com sucesso'
        objSwal.success.text = ''
        objSwal.success.html = ''

        return Swal.fire(objSwal.success).then(() => this.changeData())
      },
      clearEditOcorrencia (val) {
        this.toEditLocalOcorrencia = val
      },
      receiveOcorrencia (val) {
        this.local = val
        this.document.local = val
        this.document.registro.local = val

        this.changeData()
        this.changeTipoNaturalidade()
      },
      removeOcorrencia () {
        this.local = {}
        this.document.local = {}

        objSwal.success.title = 'Local de ocorrência excluído'
        objSwal.success.text = ''
        return Swal.fire(objSwal.success).then( () => this.changeData())
        this.changeTipoNaturalidade()
      },
      editOcorrencia () {
        this.toEditLocalOcorrencia = { ...this.local }
      },
      upperName () {
        if (this.pessoa.nome) {
          this.pessoa.nome = this.pessoa.nome.toUpperCase()
        }
      },

      // FUTURAS ATUALIZAÇÕES
      ufChanged () {
        this.naturalidade = ''
        this.changeData()
      },
      naturalidadeChanged () {
        this.localData.naturalidade = this.naturalidade
        this.pessoa.naturalidade = this.naturalidade
        this.pessoa.naturalidade_declarada = this.naturalidade
        this.pessoa.naturalidade_origem = this.naturalidade_origem
        this.changeData()
      },
      changeTipoNaturalidade (tipo = null) {
        if (!tipo) {
          tipo = this.naturalidade_origem
        }
        else {
          this.naturalidade_origem = tipo
        }

        const { alerts } = this.naturalidadeControl
        alerts.endereco_mae = false
        alerts.endereco_ocorrencia = false
        alerts.endereco_pai = false

        const showError = (message) => {
          alerts.message = message
          alerts[tipo] = true
          this.$emit('receiveError', true)
        }

        const getEnderecoMom = () => {
          // usando filter ao invés de find para caso seja duas mães
          try {
            const { pessoa: { endereco } } = this.genitores.filter(genitor => genitor.pessoa.sexo == "F")[0]

            if (!endereco) {
              showError("Mãe com o endereço ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Mãe com o endereço ainda não informado")
            return
          }
        }

        const getEnderecoPai = () => {
          // usando filter ao invés de find para caso seja duas mães
          try {
            const { pessoa: { endereco } } = this.genitores.filter(genitor => genitor.pessoa.sexo == "M")[0]

            if (!endereco) {
              showError("Pai com o endereço ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Pai com o endereço ainda não informado")
            return
          }
        }

        const getEnderecoOcorrencia = () => {
          try {
            const { endereco } = this.local

            if (!endereco) {
              showError("Local da ocorrência ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Local da ocorrência ainda não informado")
            return
          }
        }

        const tratandoEndereco = (endereco) => {
          const { cidade, uf, exterior } = endereco
          if (cidade && uf) {
            const naturalidade = `${ cidade } - ${ uf }`
            this.naturalidade = naturalidade
            this.naturalidade_declarada = naturalidade
            this.naturalidade_origem = tipo
            this.naturalidadeChanged()
            this.$emit('receiveError', false)
            return
          }

          let message = null

          if (exterior) {
            message = "O local de ocorrência não pode ser fora do Brasil"
          } else if (!cidade && uf) {
            message = "Cidade não informada"
          } else if (cidade && !uf) {
            message = "UF não informado"
          } else if (!(cidade && uf)) {
            message = "Local ainda não informado"
          }

          showError(message)
        }

        switch (tipo) {
        case 'endereco_ocorrencia':
          getEnderecoOcorrencia()
          break

        case 'endereco_mae':
          getEnderecoMom()
          break

        case 'endereco_pai':
          getEnderecoPai()
          break
        }
      },
      addAvos (genitores) {
        genitores.map((genitor, index) => {
          this.updateGenitor(genitor, index)
        })
      },
      getIdadeMae (name = null) {
        const mae = this.genitores.filter(genitor => genitor.pessoa.sexo === 'F')

        if (mae && mae.length) {
          const data_nascimento_mae = moment(mae[0].pessoa.data_nascimento, 'YYYY-MM-DD')
          const data_nascimento_filho = moment(this.pessoa.data_nascimento, 'DD/MM/YYYY')

          if (data_nascimento_mae) {
            const idade_mae = moment(data_nascimento_filho, 'DD/MM/YYYY').diff(data_nascimento_mae, 'years')

            this.idade_mae = idade_mae
          }
        } else {
          this.idade_mae = null
        }

        this.changeData(name)
      },
      getNomePai () {
        const pai = this.genitores.filter(genitor => genitor.pessoa.sexo === 'M')

        if (pai && pai.length) {
          this.nome_pai = pai[0].pessoa.nome
        } else {
          this.nome_pai = null
        }
      }
    }
  }
</script>

<style lang="scss">
@import '../../../../scss/_utilities/_exports';

.headerTitle {
  @extend %titleBox--sm;
  background-color: $color-gray-light;
}
</style>
